module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-blue-2bd49e626721b616c42667331cc5c34e.svg";